import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './utils/forceAppUpdate'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://6b57904a8899ec9b86ce5403b7537e18@o4509542097092608.ingest.de.sentry.io/4509542099714128",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

createRoot(document.getElementById("root")!).render(<App />);
